export { useOrganizationManagementOptions } from './access/api/use-position-access-grants';
export { PositionAreasDialog } from './access/PositionAreasDialog';
export { POSITION_DERIVED_QUERY_META } from './api/invalidate-position-caches';
export { useConnectJobArchitecture } from './api/use-connect-job-architecture';
export { type GlobalPositionSearchResult, useGlobalPositionSearch } from './api/use-global-position-search';
export {
    useCanEnterPositions,
    useCanReadPositions,
    useDefaultArchitectureAccess,
    useEnabledPositionBootstrap,
    usePositionBootstrap,
} from './api/use-position-bootstrap';
export { usePositionTotal } from './api/use-position-total';
export { selectArchitecture } from './architecture-selection';
export { DefaultArchitectureSetting } from './components/DefaultArchitectureSetting';
export { SendDeferredInvitationsButton } from './components/DeferredInvitations';
export { pickLocalizedText } from './localized-text';
export { PositionAssigneeMenu } from './position-detail/PositionAssigneeMenu';
export { PositionBanner } from './position-detail/PositionBanner';
export { PositionContentPanel } from './position-detail/PositionContentPanel';
export { PositionFieldsCard } from './position-detail/PositionFieldsCard';
export { PositionCloseHeader, PositionTileFrame } from './position-detail/PositionTileFrame';
export { positionJobProfile, taskTitlesInOrder } from './position-detail/position-job-profile';
export { localizedTranslation } from './position-detail/position-profile-display';
export { usePositionContentEdit } from './position-detail/use-position-content-edit';
export { connectJobArchitectureErrorTranslationKey } from './position-error';
export {
    createPositionChangelogTilePayload,
    createPositionTilePayload,
    POSITION_MANAGEMENT_CHANGELOG_TILE_TYPE,
    POSITION_MANAGEMENT_COMPARE_TILE_TYPE,
    POSITION_MANAGEMENT_POSITION_TILE_TYPE,
    POSITION_MANAGEMENT_TASK_TILE_TYPE,
    type PositionChangelogTilePayload,
    type PositionTilePayload,
    selectPositionIdFromTile,
} from './position-tile-payload';
export { positionManagementRoute } from './route';
export { LEVEL_MAPPING_RUN_SEARCH_PARAM, LEVEL_MAPPING_SEARCH_PARAM } from './search-param';
export { type PositionPlanCard, usePositionPlanCard } from './setup-wizard/api/use-position-plan-card';
export type { PlanOutcome } from './setup-wizard/plan-progress';
export { POSITION_SETUP_ROUTE_SEGMENT } from './setup-wizard/setup-wizard-url';
export { positionManagementUrlTileModule } from './url-tile';

export const loadPositionManagementPage = async () => {
    const { PositionManagementPage } = await import('./PositionManagementPage');

    return { Component: PositionManagementPage };
};

export const loadPositionSetupWizardPage = async () => {
    const { PositionSetupWizardPage } = await import('./setup-wizard/PositionSetupWizardPage');

    return { Component: PositionSetupWizardPage };
};
